
import Glide, { Autoplay, Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import "@glidejs/glide/dist/css/glide.core.min.css";

let itemCount =  document.getElementsByClassName('glide__slide').length;

console.log(itemCount);

if(itemCount) {
  new Glide('.glide.rewilding',{
    type: 'carousel',
    // perView: 1,
    // focusAt: 'center',
    autoplay:4000,
    animationDuration: 1000,
    gap:30,
    // startAt: start

  }).mount({ Autoplay, Controls, Swipe })
}



